import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const WHATSAPP_NUMBER = "351960448841";

export const ContactForm = ({ t, lang }) => {
  const whatsappMessages = {
    pt: "Olá! Tenho interesse em criar um website profissional para o meu consultório médico. Gostaria de saber mais sobre os vossos serviços e condições.",
    en: "Hello! I'm interested in creating a professional website for my medical practice. I'd like to learn more about your services and pricing."
  };

  const handleWhatsAppClick = () => {
    // Google Ads Conversion Tracking
    if (typeof gtag !== 'undefined') {
      gtag('event', 'conversion', {'send_to': 'AW-17709544469/BvIuCObJzoUcEJXoyPxB'});
    }
    const message = encodeURIComponent(whatsappMessages[lang] || whatsappMessages.pt);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, "_blank");
  };

  return (
    <section id="contacto" data-testid="contact-section" className="section-dark py-24 md:py-32 relative overflow-hidden">
      <div className="absolute bottom-0 right-1/4 w-[600px] h-[600px] bg-[radial-gradient(circle_at_center,rgba(197,160,89,0.08)_0%,transparent_70%)] pointer-events-none" />

      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24 relative z-10 text-center">
        <span className="text-sm tracking-[0.3em] uppercase text-[#C5A059] block mb-4">{t.contact.badge}</span>
        <h2 data-testid="contact-title" className="text-4xl md:text-5xl font-medium tracking-tight text-[#E5E5E5] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          {t.contact.title} <span className="text-gold-gradient">{t.contact.highlight}</span>
        </h2>
        <p className="text-[#A3A3A3] text-lg leading-relaxed mb-12 max-w-2xl mx-auto">
          {t.contact.desc}
        </p>

        <div className="glass-card p-8 md:p-12 max-w-md mx-auto">
          <div className="flex flex-col items-center gap-6">
            <div className="w-16 h-16 border border-[#25D366]/50 bg-[#25D366]/10 flex items-center justify-center rounded-full">
              <MessageCircle className="w-8 h-8 text-[#25D366]" />
            </div>
            
            <div className="text-center">
              <p className="text-xs tracking-widest uppercase text-[#A3A3A3] mb-2">WhatsApp</p>
              <button 
                onClick={handleWhatsAppClick}
                data-testid="contact-whatsapp" 
                className="text-2xl text-[#E5E5E5] hover:text-[#25D366] transition-colors font-medium"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                +351 960 448 841
              </button>
            </div>
            
            <Button
              onClick={handleWhatsAppClick}
              data-testid="contact-whatsapp-btn"
              className="w-full bg-[#25D366] hover:bg-[#20BA5C] text-white px-8 py-6 text-base tracking-widest uppercase font-medium group"
            >
              <MessageCircle className="mr-2 w-5 h-5" />
              {lang === "en" ? "Chat on WhatsApp" : "Falar no WhatsApp"}
            </Button>
          </div>
        </div>

        <div className="mt-12">
          <p className="text-xs tracking-widest uppercase text-[#A3A3A3] mb-4">{t.contact.trust}</p>
          <div className="flex justify-center gap-6">
            <span className="text-sm text-[#A3A3A3]">🔒 {t.contact.ssl}</span>
            <span className="text-sm text-[#A3A3A3]">📋 {t.contact.gdpr}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
